import { useLayoutEffect, useRef } from 'react'

const useCallbackRef = <T extends (...rest: never[]) => unknown>(
  callback: T
) => {
  const callbackRef = useRef<T>(callback)

  useLayoutEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return callbackRef
}

export default useCallbackRef
